import { useAddJobToNotificationQueue } from '../../../components/JobNotificationHub';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { Report } from '../../../../shared/model-typings';

type TaskResponse = {
  id?: number;
  jobToken: string;
  task: string;
  status?: string;
};

type QueueResponse = {
  report: Report;
  task: TaskResponse;
};

/**
 * Hook that returns a mutation to queue a public attribution report.
 * On success, shows a toast and registers the returned task with the
 * JobNotificationHub so a second toast fires when the job completes.
 *
 * The caller builds the attribution URL (including all report options as
 * query params); the mutation POSTs to that URL.
 */
export function useQueuePublicAttributionReport() {
  const addJob = useAddJobToNotificationQueue();

  return useToastedMutation({
    mutationFn: (url: string) => post<Record<string, never>, QueueResponse>(url, {}),
    onSuccess: (response) => {
      const task = response?.data?.task;
      if (task?.jobToken) {
        addJob(task.jobToken, task.task);
      }
    },
    successToastMessage: 'Your public report is being generated. You\'ll receive an email shortly.',
    errorToastMessage: 'Failed to queue public report',
  });
}
